import { isPlatform } from "@ionic/vue";
import { computed } from "vue";

export const isMobile = computed(() => isPlatform('capacitor'));
